import styled from 'styled-components';

export const Container = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 20px;
  font-family: 'Arial', sans-serif;
  color: #333;
  line-height: 1.6;
`;

export const Title = styled.h1`
  font-size: 32px;
  font-weight: semibold;
  margin-bottom: 20px;
  text-align: center;
`;

export const Subtitle = styled.h2`
  font-size: 24px;
  margin-top: 30px;
  margin-bottom: 10px;
  span {
    font-weight: bold;
    text-decoration: underline;
  }
`;

export const Paragraph = styled.p`
  font-size: 16px;
  font-weight: 300;
  margin-bottom: 16px;
  a {
    text-decoration: underline;
    color: #1e478a;
  }
`;

export const Paragraph2 = styled.div`
  p {
    font-size: 16px;
    font-weight: 300;
    margin-bottom: 16px;
    a {
      text-decoration: underline;
      color: #1e478a;
    }
  }
`;

export const Section = styled.section`
  margin-top: 20px;
`;
